module.exports = __webpack_public_path__ + "static/media/instagram-glyph.de5a6143.svg";